import React from 'react';

const UnknownError = () => (
  <div className="GenericText__content">
    <h2>Egads! Something is Broken!</h2>

    <p>
      It looks like you found something that is <em>not</em> working properly.
      The humans who built this site are working on it. Try again soon!
    </p>
  </div>
);

export default UnknownError;
